<template>
  <el-container style="height: 100%">
    <el-main>
      <el-container style="height: 100%">
        <el-aside width="550px">
          <user-detail 
            :user-id="userId"
            :person-id="personId"
            :show-buttons="false"
            model="agent"
          />
        </el-aside>
        <el-main>
          <Chat
            :user-id="userId"
            :person-id="personId"
          />
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
  import Chat from "../ui/Chat"
  import UserDetail from "../ui/UserDetail"
  export default {
    name: 'AgentCustom',
    components: {
      Chat, UserDetail,
    },
    data() {
      return {
        userId: 0,
        personId: 0,
      }
    },
    created() {
      this.userId = parseInt(this.$route.params['client_id'])
      this.personId = parseInt(this.$route.params['person_id'])
    }
  }
</script>
